import PropTypes from 'prop-types';
import CampaignGoalType from '@/constants/campaigns/CampaignGoalType';
import CampaignStatus from '@/constants/CampaignStatus';
import { TextSelectFieldValueType } from '.';

const CampaignType = {
  assignees: PropTypes.arrayOf(TextSelectFieldValueType),
  campaignId: PropTypes.string,
  campaignType: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  displayName: PropTypes.string,
  endDate: PropTypes.string,
  goalAmount: PropTypes.number,
  goalMet: PropTypes.bool,
  goalType: PropTypes.oneOf(Object.values(CampaignGoalType)),
  itemQuantity: PropTypes.number,
  itemType: PropTypes.string,
  itemValue: PropTypes.number,
  location: PropTypes.string,
  name: PropTypes.string.isRequired,
  primaryAssigneeId: PropTypes.string,
  startDate: PropTypes.string,
  status: PropTypes.oneOf(Object.values(CampaignStatus)),
  stretchAmount: PropTypes.number,
  ticketPrice: PropTypes.number,
  ticketsSold: PropTypes.number,
  updated: PropTypes.string,
  url: PropTypes.string,
  // statistics
  avgDonation: PropTypes.number,
  avgDonationPerDonor: PropTypes.number,
  expectedProgress: PropTypes.number,
  isPinned: PropTypes.bool,
  maxDonation: PropTypes.number,
  numDonations: PropTypes.number,
  numDonorConstituents: PropTypes.number,
  numNewDonors: PropTypes.number,
  numReturningDonors: PropTypes.number,
  totalAmount: PropTypes.number,
};

export default CampaignType;
